module.exports = __webpack_public_path__ + "img/brodcast-jackson-mobile.da60d4cc.jpg";